export default class progressInfo {
  public progressTxt: string = '';
  public err: string = '';
  public percent: string = '';
  public downloadStart: number = 0;
}
